export var rmJson= [
	{'id' : 1, 'name' : 'sneha'} , 
	{'id' : 2, 'name' : 'rahul'}, 
	{'id' : 3, 'name' : 'seha'}
]


//////////////////
// WEBPACK FOOTER
// ./static/fxView/js/rm_json.js
// module id = null
// module chunks = 